import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IUnassignUserDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IUnassignUserDto
>("stores.warehouses.unassignUser");

export const unassignUser = {
  ...postApis,
};
